import { Box } from '@chakra-ui/layout'
import View from 'lib/View'
import React, { Component } from 'react'
import { Button, Form, Select } from 'semantic-ui-react'

class Filter extends Component {
    constructor(props) {
        super(props)

        this.state = {
            localValue: '',
        }
    }

    render() {
        const { availableFilters, activeFilter, toExclude } = this.props

        const options = []
        for (const key in availableFilters) {
            if (key in toExclude) {
                continue
            }

            const filter = availableFilters[key]
            options.push({
                key: filter.name,
                value: key,
                text: filter.label,
            })
        }

        let activeFilterObj = null

        if (activeFilter) {
            activeFilterObj = {
                ...availableFilters[activeFilter],
                label: '',
                onChange: availableFilters[activeFilter].onChange,
            }

            if (availableFilters[activeFilter].useLocalValue) {
                activeFilterObj.value = this.state.localValue
                activeFilterObj.onChange = (e) => {
                    const newValue = availableFilters[activeFilter].onChange(e)
                    this.setState({ localValue: newValue })
                }
            }
        }

        return (
            //backgroundColor: 'rgb(215, 255, 241)',
            <View style={{ position: 'relative', width: 300, height: '100%', margin: 0, padding: 0 }}>
                {!activeFilter && (
                    <View column fullw fullh>
                        <Box textStyle="header" style={{ marginBottom: 16 }}>
                            Seleziona un filtro
                        </Box>
                        <Select
                            options={options}
                            onChange={(e, data) => {
                                // this.setState({ activeFilter: data.value })
                                if (this.props.onFilterActivated) {
                                    this.props.onFilterActivated(data.value, true)
                                }
                            }}
                        />
                    </View>
                )}
                {activeFilter && (
                    <>
                        <View column fullw fullh>
                            <Box textStyle="header">
                                {availableFilters[activeFilter].label}
                            </Box>
                            <Form>
                                <Form.Group widths="equal">
                                    <Form.Field key={`filter_${activeFilter}`} {...activeFilterObj} />
                                </Form.Group>
                            </Form>
                        </View>

                        <Button
                            size="mini"
                            basic
                            onClick={(e, data) => {
                                if (this.props.onFilterActivated) {
                                    this.props.onFilterActivated(activeFilter, false)
                                }

                                if (availableFilters[activeFilter].onReset) {
                                    availableFilters[activeFilter].onReset()
                                }

                                // this.setState({ activeFilter: null })
                            }}
                            icon="trash alternate outline"
                            color="red"
                            style={{ position: 'absolute', top: 0, right: 0 }}
                        />
                    </>
                )}
            </View>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {}
}

export default Filter
